<template>
    <div class="canvas">
        <el-row :gutter="10" class="titleNew">
                <el-col :span="3"><img src="../../assets/images/header-logo-2.png" alt=""></el-col>
                <el-col :span="7"><div class="text">上海工程咨询网</div></el-col>     
                <el-col :span="14"  :model="searchInfo">
                    <el-input class="shuru" v-model="searchInfo.findContent" clearable placeholder="请输入" size="mini">
                        <el-button type="primary" class="input-b" @click="goTotalSearch" slot="append" icon="el-icon-search"></el-button>
                    </el-input>
                </el-col>
                <!-- <el-col :span="2">
            </el-col> -->
            </el-row>
        <div class="bg">
            <img src="../../assets/images/moblie/会员天地 手机端.jpg" alt="">           
        </div>
        <div class="title-text">
            <div class="title1">会员动态</div>
            <div class="title2">Member Dynamics</div>
        </div>
        <el-row class="canvas-title mt-60" :gutter="30">
            <el-col :span="6" class="mag">                
                <div v-if="tabFlg==='1'" class="item2" @click="tabChange('1')">
                    <img src="../../assets/images/newHome/btn1.png" alt="">
                    <span class="text">会员动态</span>
                </div>
                <div v-else class="item3" @click="tabChange('1')">
                    <img src="../../assets/images/newHome/btn2.png" alt="">
                    <span class="text1">会员动态</span>
                </div>
            </el-col>
            <el-col :span="6">
                <div  v-if="tabFlg==='2'" class="item2"  @click="tabChange('2')">
                    <img src="../../assets/images/newHome/btn1.png" alt="">
                    <span class="text">会员名录</span>
                </div>
                <div v-else class="item3"  @click="tabChange('2')">
                    <img src="../../assets/images/newHome/btn2.png" alt="">
                    <span class="text1">会员名录</span>
                </div>
            </el-col>
        </el-row>
        <!-- <el-row class="canvas-title mt-60" :gutter="30">
            <el-col :span="5">
                <div :class="tabFlg==='1'?'item2':'item3'" @click="tabChange('1')">会员动态<img class="icon" src="../../assets/images/gain-jt.png"></div>
            </el-col>
            <el-col :span="4">
                <div :class="tabFlg==='2'?'item2':'item3'" @click="tabChange('2')">会员名录</div>
            </el-col>
            <el-col :span="15">
                <div class="text-right" @click="goHome">返回首页<img src="../../assets/images/fanhui.svg" alt="" /></div>
            </el-col>
        </el-row> -->
        <XNine v-if="tabFlg === '1'" :list="list" @handleDetail="jumpDocInfo" />
        <XNine2 v-else :list="list" @handleMember="handleMember" />
        <div class="page mb-40 mt-40">
            <el-pagination
                small
                @size-change="handleSizeChange"
                @current-change="handleCurrentChange"
                :current-page.sync="param.pageIndex"
                :page-size="param.pageSize"
                :page-sizes="[10, 15, 20, 30]"
                layout="prev, pager, next, jumper"
                :pager-count="5"
                :total="total">
            </el-pagination>
        </div>
        <div class="kong"></div>
    </div>
</template>
<script>
import {
    getMemberDynamicStateListApi,
    getMemberDirectorieApi
} from "@/api"
import XNine from '@/components/XNine/XNine'
import XNine2 from '@/components/XNine2/XNine2'
export default {
    components:{
        XNine,
        XNine2,
        // ImgInfoList,
        // Member
    },
    data () {
        return {
            list:[],
            searchInfo: {},
            total:0,
            param:{
                pageIndex:1,
                pageSize:10,
            },
            tabFlg:'1'
        }
    },
    watch: {
        $route: {
            handler: function(val){
                this.tabFlg = val.query.tab
                this.getlist(this.param, val.query.tab)
            }
        }
    },
    created(){
        this.tabFlg = this.$route.query.tab?this.$route.query.tab:'1'
        this.$set(this.param, 'positionType', '1')
        this.getlist(this.param, this.tabFlg)
    },
    methods: {
        async getlist(param, flg){
            let returnList = []
                param.selfType = flg
            if (flg === '1') {//会员动态
                const { data } = await getMemberDynamicStateListApi(param)
                if(data){
                    this.total = data.count
                    if (data.list){
                        data.list.forEach(item => {
                            let info = {
                                docId: item.doc_id,
                                title: item.state_title,
                                content: item.state_content,
                                showDate: item.showDate
                            }
                            returnList.push(info)
                        })
                    }
                    this.list = returnList
                }
            } else {//会员名录
                const { data } = await getMemberDirectorieApi(param)
                if(data){
                    this.total = data.count
                    if (data.list){
                        data.list.forEach(item => {
                            let info = {
                                docId: item.doc_id,
                                title: item.notice_title,
                                content: item.notice_content,
                                unit_site: item.unit_site,
                                showDate: item.showDate,
                                company:item.company,
                                position:item.positionName,
                                position_type:item.position_type
                            }
                            returnList.push(info)
                        })
                    }
                    this.list = returnList
                }
            }
        },
        goTotalSearch () {
        this.$router.push({
          path: '/XSearch',
          query: { searchInfo: JSON.stringify(this.searchInfo) }
        })
      },
        tabChange(flg){
            this.tabFlg = flg
            this.$set(this.param, 'positionType', '1')
            this.getlist(this.param, flg)
        },
        jumpDocInfo(docId){
            this.$router.push({
                path: '/DetailsPage',
                query: {
                    docId: docId,
                    position: '/XPrimaryNine',
                    positionName: '会员天地'
                }
            }, () => {})
        },
        handleMember(val){
            this.$set(this.param, 'positionType', val)
            this.$set(this.param, 'pageIndex', 1)
            this.getlist(this.param, this.tabFlg)
        },
        handleSizeChange(val){
            this.$set(this.param, 'pageSize', val)
            this.getlist(this.param, this.tabFlg)
        },
        handleCurrentChange(val){
            this.$set(this.param, 'pageIndex', val)
            this.getlist(this.param, this.tabFlg)
        },
        goHome(){
        this.$router.push({
          path: '/home'
        }, () => {})
    }
    }
}
</script>

<style lang="scss" scoped>
.canvas{
    text-align: center;
    margin: 0 auto;
    background:#F0F4F7;
    .bg{
        img{ 
            max-width: 100%;
            max-height: 100%;          
        }
    }
    .title-text{
        position: absolute;
        top:140px;
        left: 0;
        right: 0;
        z-index: 999;
        .title1{
            font-size: 35px;
            font-weight: 800;
            color: #fff;
            text-shadow: 0.1em 0.1em 0.6em #164DA0, 0 0 0.6em #164DA0, 0 0 0.6em #164DA0; //霓虹灯
        }
        .title2{
            font-size: 20px;
            color: #CCC
        }
    }
    &-title{
        width: 100%;
        text-align: left;
        // position: relative;
           padding-left: 0;
           position: absolute;
           top: 250px;
           left: 0;
           right: 0;
           z-index: 999;
           .mag{
            margin: 0 15px;
           }
            .item2{              
                height: 60px;             
                color: #fff;             
                // text-align: center;
                position: relative;              
                img{
                    height: 52px;
                }
                .text{
                    position: absolute;
                    left:26px;
                    top: 12.5px;
                    font-size: 15px;
                    width: 100%;
                    white-space:nowrap;
                }
            }
            .item3{
                margin-top: 2px;
                color: #134B9F;             
                height: 60px;           
                font-weight: 500;
                position: relative;
                img{
                    height: 41px;
                }
                .text1{                   
                    position: absolute;
                    left:26px;
                    top:10px;
                    font-size: 15px;
                    width: 100%;
                    font-weight: 600;
                    white-space:nowrap;
                }
            }
            .text-right{
                justify-items: flex-end;
                color: #134B9F;
                font-size: 19px;
                cursor: pointer;
                img{
                    width: 28px;
                }
            }
            
    }
    .kong{
        height: 30px;
    }
    .titleNew{
    padding: 15px 10px;
    position: relative;
    margin-top: 10;
    background-color: #FFF;
    img{
        height: 26px;
    }
    .text{
        color: #164DA0;
        font-size: 12px;
        font-weight: 600;
        line-height: 26px;
        white-space:nowrap;
    }
    .shuru{
        // width: 200px;
        height: 15px;
        line-height: 26px;       
    }
}

}
</style>
